export const isRadioguide = () => {
    const config = useRuntimeConfig()

    return config.public.website === 'radioguide.rent'
}
